import { format } from "date-fns";
import Input from "../../components/custom/forms/Input";
import { SalaImages } from "../../../utils/SalaUtils";

const Usuario = ({ data, provincias, onClick, onChange, filePreview }) => {
  return (
    <div className="container-md bg-light px-3 py-5" style={{maxWidth: "1000px", borderRadius: "10px"
    }}>
      <div className="row">
        <div className="col-md-12 mb-3">
          <h2 className="me-2">
            {data.id ? `USUARIO #${data.id}` : "NUEVO USUARIO"}
          </h2>

          <label className="btn btn-primary fw-normal GothamBold text-white px-4 ">
            {`${data.id ? "Aplicar cambios" : "Guardar"}`}
            <button
              className="d-none"
              name={`${data.id ? "aplicar" : "guardar"}`}
              onClick={(event) => onClick(event)}
            ></button>
          </label>

          <span className="btn btn-light mx-2">{data.status.nombre}</span>
          <span className="btn">
            {format(new Date(data.created_at), "dd/M/yyyy").toString()}
          </span>
        </div>
        <div className="col-md-12">
          <div
            className="overflow-hidden mb-2 me-md-2"
            style={{
              height: "250px",
              width: "300px",
              borderRadius: "10px",
            }}
          >
            <img
              src={data.imagen_logo}
              alt=""
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
            />
          </div>
          <div>
            <label
              className="form-label text-muted"
              style={{ fontSize: "14px" }}
            >
              Imagen principal
              <span className="fw-bold ms-2">
                Tamaño de imagen 1:1 1080 x 1080 px
              </span>
            </label>
            <Input
              onChange={onChange}
              name={"imagen_logo"}
              type={"file"}
              value={""}
              svg={
                ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
              }
              validate={{}}
              disabled={false}
            />
          </div>
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Nombre"}
            name={"nombre"}
            type={"text"}
            value={data?.nombre}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Apellido"}
            name={"apellido"}
            type={"text"}
            value={data?.apellido}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-4 col-12">
          <Input
            onChange={onChange}
            label={"Email"}
            name={"email"}
            type={"text"}
            value={data?.email}
            validate={{}}
            disabled={true}
          />
        </div>
        <div className="col-md-4 col-12">
          <Input
            onChange={onChange}
            label={"Direccion"}
            name={"direccion"}
            type={"text"}
            value={data?.direccion}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-4 col-12">
          <Input
            onChange={onChange}
            label={"Localidad"}
            name={"localidad"}
            type={"text"}
            value={data?.localidad}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-4 col-12 my-2">
          <label className="form-label text-muted d-block">Provincia</label>
          <select
            className="form-control border"
            name="provincia"
            id=""
            onChange={(e) => onChange(e)}
          >
            <option selected>{data?.provincia}</option>
            {provincias.map((provincia) => {
              return (
                <option value={provincia.provincia}>
                  {provincia.provincia}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-md-4 col-12 my-2">
          <label className="form-label text-muted d-block">
            Tipo de usuario
          </label>
          <select
            className="form-control border"
            name="rol"
            id=""
            onChange={(e) => onChange(e)}
          >
            <option selected>{data?.rol[0].descripcion}</option>
            {[
              { label: "Administrador", value: 1 },
              { label: "Productor", value: 1 },
              { label: "Sala", value: 1 },
            ].map((rol) => {
              return <option value={rol.value}>{rol.label}</option>;
            })}
          </select>
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Contraseña"}
            name={"contraseña"}
            type={"text"}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Repetir contraseña"}
            name={"repetir_contraseña"}
            type={"text"}
            validate={{}}
            disabled={false}
          />
        </div>
      </div>

      <div
        className={`row py-3 ${data?.rol[0].nombre == "prd" ? "" : "d-none"}`}
      >
        <div className="col-md-12">
          <h4 className="me-2">DATOS DE PRODUCTOR</h4>
        </div>
        <div className="col-md-12 col-12">
          <Input
            onChange={onChange}
            label={"Nombre de productor"}
            name={"productor-nombre"}
            type={"text"}
            value={data?.productor?.nombre}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Telefono"}
            name={"productor-telefono"}
            type={"text"}
            value={data?.productor?.telefono}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-4 col-12">
          <Input
            onChange={onChange}
            label={"Email"}
            name={"productor-email"}
            type={"text"}
            value={data?.productor?.prd_email}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-3 col-12">
          <Input
            onChange={onChange}
            label={"Direccion"}
            name={"productor-direccion"}
            type={"text"}
            value={data?.productor?.direccion}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-3 col-12">
          <Input
            onChange={onChange}
            label={"Localidad"}
            name={"productor-localidad"}
            type={"text"}
            value={data?.productor?.localidad}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-3 col-12 my-2">
          <label className="form-label text-muted d-block">Provincia</label>
          <select
            className="form-control border"
            name="productor-provincia"
            id=""
            onChange={(e) => onChange(e)}
          >
            <option selected>{data?.productor?.provincia}</option>
            {provincias.map((provincia) => {
              return (
                <option value={provincia.provincia}>
                  {provincia.provincia}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div
        className={`row py-3 ${data?.rol[0].nombre == "sala" ? "" : "d-none"}`}
      >
        <div className="col-md-12">
          <h4 className="me-2">DATOS DE SALA</h4>
        </div>

        <div className="col-md-12">
          <div
            className="overflow-hidden mb-2 me-md-2"
            style={{
              height: "250px",
              width: "300px",
              borderRadius: "10px",
            }}
          >
            <img
              src={data?.sala?.imagen_logo}
              alt=""
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
            />
          </div>
          <div>
            <label
              className="form-label text-muted"
              style={{ fontSize: "14px" }}
            >
              Imagen principal
              <span className="fw-bold ms-2">
                Tamaño de imagen 1:1 1080 x 1080 px
              </span>
            </label>
            <Input
              onChange={onChange}
              name={"sala-imagen_logo"}
              type={"file"}
              value={""}
              svg={
                ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
              }
              validate={{}}
              disabled={false}
            />
          </div>
        </div>

        <div className="col-md-4 col-12">
          <Input
            onChange={onChange}
            label={"Nombre de sala"}
            name={"sala-razon_social"}
            type={"text"}
            value={data?.sala?.razon_social}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-4 col-12">
          <Input
            onChange={onChange}
            label={"Telefono"}
            name={"sala-telefono"}
            type={"text"}
            value={data?.sala?.telefono}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-4 col-12">
          <Input
            onChange={onChange}
            label={"Email"}
            name={"sala-email"}
            type={"text"}
            value={data?.sala?.email}
            validate={{}}
            disabled={false}
          />
        </div>

        <div className="col-md-3 col-12">
          <Input
            onChange={onChange}
            label={"Direccion"}
            name={"sala-direccion"}
            type={"text"}
            value={data?.sala?.direccion}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-3 col-12">
          <Input
            onChange={onChange}
            label={"Localidad"}
            name={"sala-localidad"}
            type={"text"}
            value={data?.sala?.localidad}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-3 col-12 my-2">
          <label className="form-label text-muted d-block">Provincia</label>
          <select
            className="form-control border"
            name="sala-provincia"
            id=""
            onChange={(e) => onChange(e)}
          >
            <option selected>{data?.sala?.provincia}</option>
            {provincias.map((provincia) => {
              return (
                <option value={provincia.provincia}>
                  {provincia.provincia}
                </option>
              );
            })}
          </select>
        </div>

        <div className="col-md-12">
          <div
            className="overflow-hidden mb-2 me-md-2"
            style={{
              height: "250px",
              width: "300px",
              borderRadius: "10px",
            }}
          >
            <img
              src={data?.sala?.imagen_logo}
              alt=""
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
            />
          </div>
          <div>
            <label
              className="form-label text-muted"
              style={{ fontSize: "14px" }}
            >
              Galeria de imagenes
              <span className="fw-bold ms-2">
                Tamaño de imagen 1:1 1080 x 1080 px
              </span>
            </label>
            <Input
              onChange={onChange}
              name={"sala-imagen_logo"}
              type={"file"}
              value={""}
              svg={
                ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
              }
              validate={{}}
              disabled={false}
            />
          </div>
        </div>

        <div className="col-md-12">
            <div className="row">
                {
                    SalaImages(data?.sala).map((img, index) => {
                        return (
                            <div className="col-auto p-1">
                                <label className="btn" style={{width: "300px", height: "200px"}}>
                                <img src={img} alt=""
                                className="w-100 h-100"
                                style={{objectFit: "cover"}}
                                />
                                <button className="d-none"
                                name="eliminar-image-galeria"
                                onClick={(e) => onClick(e, index+1)}
                                ></button>
                                </label>
                            </div>
                        )
                    })
                }
            </div>
        </div>
      </div>

      {/* Sección Datos de Facturación */}
      <div className="row py-3">
        <div className="col-md-12">
          <h4 className="me-2">DATOS DE FACTURACIÓN</h4>
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Entidad Bancaria"}
            name={"facturacion-entidad"}
            type={"text"}
            value={data?.facturacion?.entidad}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"CBU"}
            name={"facturacion-cbu"}
            type={"text"}
            value={data?.facturacion?.cbu}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6 col-12 my-2">
          <label className="form-label text-muted d-block">Dato Fiscal</label>
          <select
            className="form-control border"
            name="facturacion-dato_fiscal"
            value={data?.facturacion?.dato_fiscal || ""}
            onChange={(e) => onChange(e)}
          >
            <option value="">Seleccionar condición fiscal</option>
            <option value="Responsable_inscripto">Responsable Inscripto</option>
            <option value="IVA_Exento">IVA Exento</option>
            <option value="Monotributo">Monotributo</option>
          </select>
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Porcentaje"}
            name={"facturacion-porcentaje"}
            type={"number"}
            value={data?.facturacion?.porcentaje}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Comprobante AFIP"}
            name={"facturacion-comprobante_afip"}
            type={"file"}
            value={""}
            validate={{}}
            disabled={false}
          />
          {filePreview?.comprobante_afip && (
            <div className="mt-2">
              {typeof filePreview.comprobante_afip === 'string' && filePreview.comprobante_afip !== 'pdf' ? (
                <img 
                  src={filePreview.comprobante_afip} 
                  alt="Vista previa" 
                  className="img-thumbnail"
                  style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                />
              ) : filePreview.comprobante_afip === 'pdf' ? (
                <div className="alert alert-info d-inline-block">
                  <i className="fas fa-file-pdf me-2"></i>
                  PDF seleccionado
                </div>
              ) : (
                <div className="alert alert-secondary d-inline-block">
                  <i className="fas fa-file me-2"></i>
                  {filePreview.comprobante_afip}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Comprobante CBU"}
            name={"facturacion-comprobante_cbu"}
            type={"file"}
            value={""}
            validate={{}}
            disabled={false}
          />
          {filePreview?.comprobante_cbu && (
            <div className="mt-2">
              {typeof filePreview.comprobante_cbu === 'string' && filePreview.comprobante_cbu !== 'pdf' ? (
                <img 
                  src={filePreview.comprobante_cbu} 
                  alt="Vista previa" 
                  className="img-thumbnail"
                  style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                />
              ) : filePreview.comprobante_cbu === 'pdf' ? (
                <div className="alert alert-info d-inline-block">
                  <i className="fas fa-file-pdf me-2"></i>
                  PDF seleccionado
                </div>
              ) : (
                <div className="alert alert-secondary d-inline-block">
                  <i className="fas fa-file me-2"></i>
                  {filePreview.comprobante_cbu}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="col-md-6 col-12">
          <Input
            onChange={onChange}
            label={"Comprobante Entidad"}
            name={"facturacion-comprobante_entidad"}
            type={"file"}
            value={""}
            validate={{}}
            disabled={false}
          />
          {filePreview?.comprobante_entidad && (
            <div className="mt-2">
              {typeof filePreview.comprobante_entidad === 'string' && filePreview.comprobante_entidad !== 'pdf' ? (
                <img 
                  src={filePreview.comprobante_entidad} 
                  alt="Vista previa" 
                  className="img-thumbnail"
                  style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                />
              ) : filePreview.comprobante_entidad === 'pdf' ? (
                <div className="alert alert-info d-inline-block">
                  <i className="fas fa-file-pdf me-2"></i>
                  PDF seleccionado
                </div>
              ) : (
                <div className="alert alert-secondary d-inline-block">
                  <i className="fas fa-file me-2"></i>
                  {filePreview.comprobante_entidad}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Usuario;
